import { createAction, createReducer } from '../../util/redux';
import { merge } from 'ramda';

/*
 |--------------------------------------------------------------------------
 | Default state
 |--------------------------------------------------------------------------
 */

const defaultState = {};

/*
 |--------------------------------------------------------------------------
 | Actions - anything that changes the store
 |--------------------------------------------------------------------------
 */

const UPDATE_USER = 'UPDATE_USER';
const updateUser = createAction(UPDATE_USER);
function updateUserHandler(state, { payload }) {
  return merge(state, payload);
}

const UPDATE_USER_ADDRESSES = 'UPDATE_USER_ADDRESSES';
const updateUserAddresses = createAction(UPDATE_USER_ADDRESSES);
function updateUserAddressesHandler(state, { payload }) {
  return {
    ...state,
    addresses: payload,
  };
}

const UPDATE_USER_EXTENSIONS = 'UPDATE_USER_EXTENSIONS';
const updateUserExtensions = createAction(UPDATE_USER_EXTENSIONS);
function updateUserExtensionsHandler(state, { payload }) {
  return {
    ...state,
    extensions: payload,
  };
}

const UPDATE_USER_MEDIA = 'UPDATE_USER_MEDIA';
const updateUserMedia = createAction(UPDATE_USER_MEDIA);
function updateUserMediaHandler(state, { payload }) {
  return {
    ...state,
    media: payload,
  };
}

const UPDATE_USER_MEMBERSHIP = 'UPDATE_USER_MEMBERSHIP';
const updateUserMembership = createAction(UPDATE_USER_MEMBERSHIP);
function updateUserMembershipHandler(state, { payload }) {
  return {
    ...state,
    membership: payload,
  };
}

const UPDATE_USER_LATEST_MEMBERSHIP = 'UPDATE_USER_LATEST_MEMBERSHIP';
const updateUserLatestMembership = createAction(UPDATE_USER_LATEST_MEMBERSHIP);
function updateUserLatestMembershipHandler(state, { payload }) {
  return {
    ...state,
    latestMembershipRequest: payload,
  };
}

/*
 |--------------------------------------------------------------------------
 | Thunks - same as actions but returns a promise. Good for chaining
 |--------------------------------------------------------------------------
 */

/*
 |--------------------------------------------------------------------------
 | Reducer - maps the action to the action handler
 |--------------------------------------------------------------------------
 */

export const userReducer = createReducer(defaultState, {
  [UPDATE_USER]: updateUserHandler,
  [UPDATE_USER_ADDRESSES]: updateUserAddressesHandler,
  [UPDATE_USER_EXTENSIONS]: updateUserExtensionsHandler,
  [UPDATE_USER_MEDIA]: updateUserMediaHandler,
  [UPDATE_USER_MEMBERSHIP]: updateUserMembershipHandler,
  [UPDATE_USER_LATEST_MEMBERSHIP]: updateUserLatestMembershipHandler,
});

/*
 |--------------------------------------------------------------------------
 | Action Exports
 |--------------------------------------------------------------------------
 */
export default {
  updateUser,
  updateUserAddresses,
  updateUserExtensions,
  updateUserMedia,
  updateUserMembership,
  updateUserLatestMembership,
};
